/** 세로 폰이면 요소를 90° 돌려 가로로 보여 준다(사용자 요청: 돌리라고 하지 말고 그냥 가로로).
 *  크기·위치는 iOS 사파리의 주소창·툴바를 뺀 **실제 보이는 영역(visualViewport)** 기준 — innerHeight 를 쓰면 위쪽이 주소창 밑으로 밀린다.
 *  돌린 요소의 CSS 크기는 (보이는 높이 × 보이는 폭). 입력 좌표 변환은 input.ts clientToLocal. */
function viewport(): { w: number; h: number; top: number; left: number } {
  const vv = window.visualViewport;
  if (vv) return { w: Math.round(vv.width), h: Math.round(vv.height), top: Math.round(vv.offsetTop), left: Math.round(vv.offsetLeft) };
  return { w: window.innerWidth, h: window.innerHeight, top: 0, left: 0 };
}

export function isPortrait(): boolean {
  const v = viewport();
  return v.h > v.w;
}

/** 요소를 세로/가로에 맞춰 놓고 (논리 폭, 논리 높이)를 돌려준다. */
export function fitRotation(el: HTMLElement): [number, number] {
  const v = viewport();
  el.style.left = `${v.left}px`; el.style.top = `${v.top}px`;
  if (v.h > v.w) {
    el.classList.add('rotated');
    el.style.width = `${v.h}px`; el.style.height = `${v.w}px`;
    return [v.h, v.w];
  }
  el.classList.remove('rotated');
  el.style.width = `${v.w}px`; el.style.height = `${v.h}px`;
  return [v.w, v.h];
}

/** 뷰포트(보이는 영역) 크기·오프셋이 바뀌면 cb. 이벤트가 안 오는 브라우저(앱 내 브라우저 등)를 위해 250ms 폴링도 한다. */
export function watchViewport(cb: () => void): () => void {
  let last = '';
  const check = () => {
    const v = viewport();
    const key = `${v.w}x${v.h}@${v.left},${v.top}`;
    if (key !== last) { last = key; cb(); }
  };
  const id = setInterval(check, 250);
  window.addEventListener('resize', check);
  window.visualViewport?.addEventListener('resize', check);
  window.visualViewport?.addEventListener('scroll', check);
  window.addEventListener('scroll', () => window.scrollTo(0, 0));
  check();
  return () => {
    clearInterval(id);
    window.removeEventListener('resize', check);
    window.visualViewport?.removeEventListener('resize', check);
    window.visualViewport?.removeEventListener('scroll', check);
  };
}
